module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pz11-1"
    }
  }, [_vm._v("\n\t\t\t\t\tContents ")]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-2"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/chapter01#pz17-1",
      "id": "ch1"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("\n\t\t\t\t\tOut of Nothing, Something")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-4"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/chapter02#pz20-2",
      "id": "ch2"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02"
    }
  }, [_vm._v("\n\t\t\t\t\tSo Many Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-6"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/chapter03#pz24-2",
      "id": "ch3"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03"
    }
  }, [_vm._v("\n\t\t\t\t\tThomas Jefferson: The Episcopalian Unitarian")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-11"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter04#pz30-2",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tThe Power of One:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Vote Matters, and One Percent Is Significant")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-14"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter05#pz35-1",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tFour of John Steinbeck’s Novels:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Selective, Annotative Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-17"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter06#pz51-2",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tWisdom Comes Quietly")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-22"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter07#pz58-2",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tPensees: Small Thoughts and Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz11-25"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter08#pz66-1",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz11-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tWhat Is Holy?")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-1"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter09#pz70-2",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tIn Search of a Quest")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-3"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter10#pz73-1",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tMy Sanctuary")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-7"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter11#pz76-2",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tAfter Reading Jean Paul Sartre’s: "), _c('i', [_vm._v("No Exit")]), _vm._v(" and "), _c('i', [_vm._v("The Flies")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-9"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter12#pz81-1",
      "id": "ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tRead All About It")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-13"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter13#pz88-2",
      "id": "ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tWinter: A Metaphorical Season")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-16"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter14#pz91-2",
      "id": "ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tObserve Closely")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-18"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter15#pz94-2",
      "id": "ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tMy World, My Words")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-22"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter16#pz104-2",
      "id": "ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tBeethoven or Baseball?")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz12-25"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter17#pz108-1",
      "id": "ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz12-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tHappy Birthday, "), _c('i', [_vm._v("Fine Lines")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-1"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter18#pz110-1",
      "id": "ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tLittle Birds with Broken Wings:The Beginning of "), _c('i', [_vm._v("Fine Lines")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-4"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter19#pz117-2",
      "id": "ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tOh, the Words We Use")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-7"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter20#pz121-1",
      "id": "ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tJohn Gay vs. Bertoldt Brecht: The Three Penny Opera")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-10"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter21#pz125-1",
      "id": "ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tVonnegut and Morris: Two Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-13"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter22#pz128-2",
      "id": "ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tDear Me")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-16"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter23#pz135-2",
      "id": "ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\t“Let Them Farm in a Flower Pot”")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-19"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter24#pz141-2",
      "id": "ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tBelieve in Small Things")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-22"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter25#pz147-2",
      "id": "ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tAn Affair of Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz13-25"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter26#pz153-2",
      "id": "ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz13-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tAll Good Things")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-1"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter27#pz157-2",
      "id": "ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Aztec")]), _vm._v(": A Review and Reflection")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-4"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter28#pz163-1",
      "id": "ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tDream Well")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-7"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter29#pz167-2",
      "id": "ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tMother’s Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-10"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter30#pz171-1",
      "id": "ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Memoirs of Pancho Villa")]), _vm._v(" by Martín Luis Guzmán: A Review")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-13"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter31#pz178-2",
      "id": "ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tOne Firefly")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-16"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter32#pz183-2",
      "id": "ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tLes Whipp: A Lighthouse Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-19"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter33#pz187-2",
      "id": "ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tHallelujah")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-22"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter34#pz191-2",
      "id": "ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tProverbial Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz14-25"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter35#pz196-2",
      "id": "ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz14-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tThe Keys to Understanding")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz15-1"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter36#pz201-2",
      "id": "ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz15-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tTomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz15-4"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter37#pz210-2",
      "id": "ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz15-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tSuch a Wonderful Gift")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz15-7"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter38#pz216-1",
      "id": "ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz15-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tThe Goal Is the Soul: An Interview of David Martin by Sjon Ashby")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz15-10"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter39#pz239-2",
      "id": "ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz15-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tRipples of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    attrs: {
      "id": "pz15-14"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/chapter40#pz243-1",
      "id": "ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt1",
    attrs: {
      "id": "pz15-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\n\t\t\t\t\tAfter 20 Years: "), _c('i', [_vm._v("Fine Lines")]), _vm._v(" Celebrates the “Best of the Best”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0